// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3_MGc","emails":"CreateEditClinics_emails__oled9","emailTagLabel":"CreateEditClinics_emailTagLabel__1Ti1e"};